
import AppLink from "./AppLink"
import stubDirectives from "../mixins/stubDirectives"

export default {
  components: {
    AppLink
  },
  mixins: [stubDirectives],
  props: {
    iconText: {
      type: Array,
      required: true
    }
  }
}
